import React ,{useState,useEffect} from "react";
import { Col, Container, Row } from "react-bootstrap";
import { TODIS_FORM_FIELD_OPTIONS_WITH_CHANGE, TODIS_FORM_FIELD_CHECK, TODIS_FORM_FIELD_GROUP, TODIS_FORM_FIELD, TODIS_FORM_FIELD_SL, TODIS_FORM_FIELD_YES_NO, TODIS_FORM_FIELD_OPTIONS, TODIS_FORM_FIELD_OPTIONS_SL, TODIS_FORM_FIELD_DATE, TODIS_FORM_FIELD_DATE_SL } from "../../components/Forms";
import { BsFillArrowDownSquareFill, BsSortDownAlt, BsTrashFill, BsSearch, BsFillGearFill } from "react-icons/bs";
import { TODIS_BTN_PRIMARY, TODIS_BTN_DANGER, TODIS_BTN_SECUNDARY_LIGHT } from "../../components/Buttons";
import { AuxiliaryService } from "../../HttpService/AuxiliaryService";
import Table from 'react-bootstrap/Table';
import { Formik, Field, Form, ErrorMessage, useFormik } from 'formik';
import dateFormat, { masks } from "dateformat";
import style from "./form.module.scss";


const TODIS_FORM_FILTER_ADVANCE = (props) => {
    
    const [category, setRoadsTentCategory] = useState([])
    const [regionalPartner, setRegionalPartner] = useState([])
    const [sector, setSector] = useState([])    
    const [showRow, setShowRow] = useState(false)
    const [filter, setFilter] = useState([])
    const [filter2, setFilter2] = useState([])
    const [filter3, setFilter3] = useState([])
    const [dateForm, setDateForm] = useState("")

    const getDataSelect = async() => {        
        const query = await new AuxiliaryService('auxData/tentcategory,regionalpartner,sector').getAuxiliaries();                
            query.map((option,index) => {                    
                    if(option.txtNameTable=="regionalpartner")
                    setRegionalPartner(option.auxtableDetailsDTOList)
                    if(option.txtNameTable=="tentcategory")
                    setRoadsTentCategory(option.auxtableDetailsDTOList)
                    if(option.txtNameTable=="sector")
                    setSector(option.auxtableDetailsDTOList)
            })
    }

    const getValores = (e) => {
        setFilter([]);
        if (e.target.value != "") {
            setFilter(prevState => 
                {
                    let newState = [...prevState];
                    let val = sector.find(t => t.idAuxtabledetail==e.target.value );
                    newState.push(val);
                    return newState;
                }
            );
        }
    }
    const getValores2 = (e) => {
        setFilter2([]);
        if (e.target.value != "") {
            setFilter2(prevState => 
                {
                    let newState = [...prevState];
                    let val = regionalPartner.find(t => t.idAuxtabledetail==e.target.value );
                    newState.push(val);
                    return newState;
                }
            );
        }
    }
    const getValores3 = (e) => {
        setFilter3([]);
        if (e.target.value != "") {
            setFilter3(prevState => 
                {
                    let newState = [...prevState];
                    let val = category.find(t => t.idAuxtabledetail==e.target.value );
                    newState.push(val);
                    return newState;
                }
            );
        }
    }    
    const getValoresDate = (e) => {
        setDateForm(dateFormat(e, "mm/dd/yyyy"))
    }
    const removeFilter = (e) => {
        setShowRow(false);
        setDateForm("");
        setFilter([]);
        setFilter2([]);
        setFilter3([]);
    }

    const search = (e) => {
        setShowRow(true);
        var json = {
            regionalPartner:"",
            sector:"",
            date:""
        };
        props.sendFilterData(json);
    }

    useEffect(() => {
            getDataSelect();
    }, []);

    return (
        <div>
            <Formik initialValues={ {"date_search":""} }>
                <Form className={style.formSearch}>
                    <Container fluid>
                        <Row className="pt-2">
                            <Col lg={7}>
                                <Row>
                                    <Col lg={2} className="p-1">
                                        <TODIS_FORM_FIELD_OPTIONS_WITH_CHANGE onchange={getValores2} type="sharing" notLabel={false} id="regional_partner" name="regional_partner" options={regionalPartner} placeholder="Regional Partner" nameValue="countryCode" nameDesc="txtDescription"/>
                                    </Col>
                                    <Col lg={2} className="p-1">
                                        <TODIS_FORM_FIELD_OPTIONS_WITH_CHANGE onchange={getValores} type="sharing" notLabel={false} id="sector" name="sector" options={sector} placeholder="Sector" nameValue="countryCode" nameDesc="txtDescription"/>
                                    </Col>                                
                                    <Col lg={2} className="p-1">
                                        <TODIS_FORM_FIELD_OPTIONS_WITH_CHANGE onchange={getValores3} type="sharing" notLabel={false} id="tent_category" label="Label" name="tent_category" options={category} placeholder="TENT Category" nameValue="countryCode" nameDesc="txtDescription"/>
                                    </Col>                                
                                    <Col lg={2} className="p-1">
                                        <TODIS_FORM_FIELD_DATE onchange={getValoresDate} isChange={true} type="sharing" notLabel={false} id="date_search" name="date_search" placeholder="Date"/>
                                    </Col>
                                    <Col lg={2} className="p-0">
                                        {<div class="mt-3">
                                            <TODIS_FORM_FIELD_CHECK type="sharing" id="selectAll" label="Include invalid Data" selectAll={()=> console.log('')}/>
                                        </div>}
                                    </Col>
                                    <Col lg={2} className="p-1">
                                        {<div class="mt-3">
                                            <TODIS_BTN_DANGER onclick={removeFilter} variant="primary" icon={BsTrashFill} title="Remove Filters"/>
                                        </div>}
                                    </Col>                                    
                                </Row>                    
                            </Col>
                            <Col lg={5}>                           
                                <Row>
                                    <Col lg={6} className="row">
                                        <Col lg={6} className="p-0">
                                            <TODIS_BTN_PRIMARY onclick={search} variant="primary" classes="fw-bolder" icon={BsSearch} title="APPLY SEARCH"/>
                                        </Col>  
                                    </Col> 
                                    <Col lg={6} >
                                        <Col className="float-end">
                                            <TODIS_BTN_PRIMARY variant="primary" classes="fw-bolder" icon={BsFillArrowDownSquareFill} title="Export Data"/>
                                        </Col>  
                                    </Col>
                                </Row>                            
                            </Col>                
                        </Row>
                    </Container>
                </Form>
            </Formik>
            <div id="tblResult">

            </div>
            {/* <Table hover size="sm" responsive className={showRow? "bg-whit mt-3": "hide"}>
                <thead>
                    <tr>
                    <th>#</th>
                    {Array.from({ length: 6 }).map((_, index) => (
                        <th key={index}>Table heading</th>
                    ))}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                    <td>1</td>
                    {Array.from({ length: 6 }).map((_, index) => (
                        <td key={index}>Section Name {index}</td>
                    ))}
                    </tr>
                    <tr>
                    <td>2</td>
                    {Array.from({ length: 6 }).map((_, index) => (
                        <td key={index}>Section Name {index}</td>
                    ))}
                    </tr>
                    <tr>
                    <td>3</td>
                    {Array.from({ length: 6 }).map((_, index) => (
                        <td key={index}>Section Name {index}</td>
                    ))}
                    </tr>
                </tbody>
            </Table>             */}
        </div>
    )
}

export default TODIS_FORM_FILTER_ADVANCE;